@import '~style-sheet-helpers/core.less';

.single-date-picker {
  line-height: 1;
}
